import { css } from "styled-components";

import { MEDIA_QUERY } from "./breakpoints";

// Template-literal helpers for styled-components media queries. Re-tagging with
// css(...args) preserves nested ${({ theme }) => ...} interpolations inside.
// Usage:  ${media.maxTablet`width: 100%; margin-left: 0;`}
export const media = {
  maxMobile: (...args) => css`
    @media ${MEDIA_QUERY.maxMobile} {
      ${css(...args)}
    }
  `,
  maxTablet: (...args) => css`
    @media ${MEDIA_QUERY.maxTablet} {
      ${css(...args)}
    }
  `,
  maxDesktop: (...args) => css`
    @media ${MEDIA_QUERY.maxDesktop} {
      ${css(...args)}
    }
  `,
};

// Reusable replacement for a bare `width: NNNpx` on cards/panels/modals so they
// shrink to full width on phones instead of overflowing the viewport.
export const responsiveFixedWidth = (px) => css`
  width: ${px}px;
  max-width: 100%;
  ${media.maxMobile`
    width: 100%;
  `}
`;
